module.exports = __webpack_public_path__ + "img/LIMPIEZA.fb6975b1.png";